import { ApiUrlPrepare } from "@lib/helpers/ApiHelper";
import { API } from "@lib/services/http";
import { ApiParams, PaginationType } from "@lib/types";
import {
  MarketPlaceEmailTemplate,
  MarketPlaceSummary,
  MarketPlaceTradeAdvise,
  MarketPlaceTraderAnalysis,
  MarketPlaceWhatsappMessage,
} from "@lib/types/MarketPlace";
import { MarketPlaceFraudDetection } from "@lib/types/FraudDetection";
import { MarketPlaceNoteValidation } from "@lib/types/NoteValidation";

export const apiGetMarketPlaceEmailTemplate = async (id: string) => {
  const url = `/market-place/email-template/${id}`;
  return API.get<MarketPlaceEmailTemplate>(url);
};

export const apiGetMarketPlaceEmailTemplates = async <T extends ApiParams>(
  params: T,
) => {
  const url = ApiUrlPrepare({ params, url: `/market-place/email-template` });
  return API.get<PaginationType<MarketPlaceEmailTemplate>>(url);
};

export const apiGetMarketPlaceSummary = async (id: string) => {
  const url = `/market-place/summary/${id}`;
  return API.get<MarketPlaceSummary>(url);
};

export const apiGetMarketPlaceSummaries = async <T extends ApiParams>(
  params: T,
) => {
  const url = ApiUrlPrepare({ params, url: `/market-place/summary` });
  return API.get<PaginationType<MarketPlaceSummary>>(url);
};

export const apiGetMarketPlaceWhatsappMessage = async (id: string) => {
  const url = `/market-place/whatsapp-message/${id}`;
  return API.get<MarketPlaceWhatsappMessage>(url);
};

export const apiGetMarketPlaceWhatsappMessages = async <T extends ApiParams>(
  params: T,
) => {
  const url = ApiUrlPrepare({ params, url: `/market-place/whatsapp-message` });
  return API.get<PaginationType<MarketPlaceWhatsappMessage>>(url);
};

export const apiGetMarketPlaceTraderAnalysis = async (id: string) => {
  const url = `/market-place/trader-analysis/${id}`;
  return API.get<MarketPlaceTraderAnalysis>(url);
};

export const apiGetMarketPlaceTraderAnalyses = async <T extends ApiParams>(
  params: T,
) => {
  const url = ApiUrlPrepare({ params, url: `/market-place/trader-analysis` });
  return API.get<PaginationType<MarketPlaceTraderAnalysis>>(url);
};

export const apiGetMarketPlaceTradeAdvise = async (id: string) => {
  const url = `/market-place/trade-advise/${id}`;
  return API.get<MarketPlaceTradeAdvise>(url);
};

export const apiGetMarketPlaceTradeAdvises = async <T extends ApiParams>(
  params: T,
) => {
  const url = ApiUrlPrepare({ params, url: `/market-place/trade-advise` });
  return API.get<PaginationType<MarketPlaceTradeAdvise>>(url);
};

export const apiGetMarketPlaceNoteValidation = async <T extends ApiParams>(
  params: T,
) => {
  const url = ApiUrlPrepare({ params, url: `/market-place/note-validation` });
  return API.get<PaginationType<MarketPlaceNoteValidation>>(url);
};

export const apiGetMarketPlaceFraudDetection = async <T extends ApiParams>(
  params: T,
) => {
  const url = ApiUrlPrepare({ params, url: `/market-place/fraud-detection` });
  return API.get<PaginationType<MarketPlaceFraudDetection>>(url);
};

export const apiGetMarketPlaceFraudDetectionById = async (id: string) => {
  const url = `/market-place/fraud-detection/${id}`;
  return API.get<MarketPlaceFraudDetection>(url);
};

export const apiCreateMarketPlaceFraudDetection = async (
  data: Partial<MarketPlaceFraudDetection>,
) => {
  const url = `/market-place/fraud-detection`;
  return API.post<MarketPlaceFraudDetection>(url, data);
};

export const apiBulkCreateMarketPlaceFraudDetection = async (
  data: Partial<MarketPlaceFraudDetection>[],
) => {
  const url = `/market-place/fraud-detection/bulk`;
  return API.post<MarketPlaceFraudDetection[]>(url, data);
};

export const apiUpdateMarketPlaceFraudDetection = async (
  data: Partial<MarketPlaceFraudDetection>,
) => {
  const { id } = data;
  const url = `/market-place/fraud-detection/${id}`;
  return API.patch<MarketPlaceFraudDetection>(url, data);
};

export const apiReplaceMarketPlaceFraudDetection = async (
  data: MarketPlaceFraudDetection,
) => {
  const { id } = data;
  const url = `/market-place/fraud-detection/${id}`;
  return API.put<MarketPlaceFraudDetection>(url, data);
};

export const apiDeleteMarketPlaceFraudDetection = async (id: string) => {
  const url = `/market-place/fraud-detection/${id}`;
  return API.delete<void>(url);
};

export const apiGetMarketPlaceFraudDetectionRemote = async <
  T extends ApiParams,
>(
  params?: T,
) => {
  const url = ApiUrlPrepare({
    params,
    url: `/market-place/fraud-detection/remote`,
  });
  return API.get(url);
};

export const apiPostMarketPlaceFraudDetectionRemote = async (
  data: Partial<MarketPlaceFraudDetection>,
) => {
  const url = `/market-place/fraud-detection/remote`;
  return API.post<MarketPlaceFraudDetection>(url, data);
};
